import React from 'react';
import { Box, Card } from '@mui/material';
import clinicImage from '../../assets/qrcode-logo.png';
import { useParams } from 'react-router-dom';
import { fetchDoctorById } from '../../api';

import EditForm from './components/EditForm';
import Info from './components/Info';
import ClaimForm from './components/ClaimForm';
import {
  DEFAULT_FEEDBACK,
  Field,
  type Feedback,
  type Value,
} from '../../interfaces/qrcode-feedback.type';
import type { IQrcodeDoctor } from '../../interfaces/qrcode-doctor.type';

import './styles.css';
import Final from './components/Final';

enum Step {
  Info,
  Form,
  Success,
  Claim,
}

function QrcodeFeedbackPage() {
  const { slug }: { slug?: string } = useParams();
  const [doctor, setDoctor] = React.useState<IQrcodeDoctor>();
  const [feedback, setFeedback] = React.useState<Feedback>(DEFAULT_FEEDBACK);

  const [step, setStep] = React.useState(Step.Info);

  const [_loading, setLoading] = React.useState(false);

  const handleSetFeedback = (field: string) => (value: Value) => {
    setFeedback((feedback) => ({
      ...feedback,
      [field]: value,
    }));
  };

  React.useLayoutEffect(() => {
    if (slug) {
      setLoading(true);
      fetchDoctorById(slug)
        .then((doctor) => setDoctor(doctor))
        .catch((error) => console.log('error', error))
        .finally(() => {
          setLoading(false);
        });
    }
  }, [slug]);

  React.useEffect(() => {
    if (doctor) {
      handleSetFeedback(Field.DoctorId)(doctor.id);
      handleSetFeedback(Field.ClinicId)(doctor.clinicId);
    }
  }, [doctor]);

  if (!doctor) {
    return <span>... loading</span>;
  }

  return (
    <Box className='feedback-page qrcode-feedback-page'>
      <Card className='feedback-page__card card'>
        <Box className='card__image-wrap'>
          <img
            className='card__image'
            src={clinicImage}
            alt='клиника Здоровье'
          />
        </Box>

        {step === Step.Info ? (
          <Info doctor={doctor} next={() => setStep(Step.Form)} />
        ) : null}

        {step === Step.Form ? (
          <EditForm
            doctor={doctor}
            goClaim={() => setStep(Step.Claim)}
            feedback={feedback}
            onChange={handleSetFeedback}
          />
        ) : null}

        {step === Step.Claim ? (
          <ClaimForm
            feedback={feedback}
            onChange={handleSetFeedback}
            goSuccess={() => setStep(Step.Success)}
          />
        ) : null}

        {step === Step.Success ? <Final /> : null}
      </Card>
    </Box>
  );
}

export default QrcodeFeedbackPage;
